module.exports = __webpack_public_path__ + "img/inspiration_02@2x.2e1dec4.webp";